import axios from 'axios'
import * as MODULES from '../module-codes'
import { v4 as uuidv4 } from 'uuid';

export const state = {
  title: '',
  conversations: [],
  showChat: false,
  bubble: false,
  unread: 0,
  bubbleOpen: false,
  onChatPage: false,
  loading: true,
  sessionToken: null,
  defaultChatbotCredentials: null,
  defaultChatbotAgent: null,
  lastContexts: [],
  watchedRecipients: [],
  watchedResponses: [],
  typing: [],
}

export const getters = {
  unreadMessages: state => {
    let unread = 0
    state.conversations.forEach(conversation => {
      unread += conversation.unread
    })
    return unread
  },
  bubbleOpenState: state => {
    return state.bubbleOpen
  }
}

// dispatch
export const actions = {
  addWatchedRecipient: ({commit, dispatch}, content) => {
    commit('ADD_WATCHED_RECIPIENT', content)
    dispatch('saveState')
  },
  addWatchedResponse: ({commit, dispatch}, content) => {
    commit('ADD_WATCHED_RESPONSE', content)
    dispatch('saveState')
  },
  showChat: ({ commit }) => {
    commit('SHOW_CHAT')
  },
  addUnread: ({ commit }, numUnread) => {
    commit('ADD_UNREAD', numUnread)
  },
  resetUnread: ({ commit }, conversation) => {
    commit('RESET_UNREAD', conversation)
  },
  populateChatFromDB: ({ commit, rootState }) => {
    axios
      .post('/api/getGroup', {
        params: {
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId,
        },
      })
      .then(response => {
        axios
          .post('/api/pcs/chat', {
            params: {
              pcs: localStorage.getItem('pcs'),
              group: response.data,
              classId: rootState.auth.classId,
            },
          })
          .then(response => {
            let settings = response.data
            commit('INIT_CHAT', settings)
          })
      })
  },
  populateFromDB: async ({ commit, dispatch, state, rootState }, payload) => {
    try {
      if (payload) {
        axios
          .post('/api/getGroup', {
            params: {
              pcs: localStorage.getItem('pcs'),
              classId: rootState.auth.classId,
            },
          })
          .then(response => {
            axios.post('/api/pcs/chat', {
              params: {
                pcs: localStorage.getItem('pcs'),
                group: response.data,
                classId: rootState.auth.classId,
              },
            }).then(response => {
              let data = response.data.users.concat(response.data.channels)
              let bubble = response.data.bubble
              let temp = []
              let unread = 0
              let defaultChatbotAgent = response.data.defaultChatbotAgent
              let defaultChatbotCredentials = response.data.defaultChatbotCredentials
              let title = response.data.title

              data.forEach(user => {
                let set = false
                let tempConvo = null
                payload.conversations.forEach(convo => {
                  if (user.id === convo.id) {
                    convo.role = user.role
                    tempConvo = convo
                    set = true
                  }
                })
                if (!set) {
                  user.messages = []
                  user.unread = 0
                  // payload.conversations.push(user)
                  temp.push(user)
                } else {
                  temp.push(tempConvo)
                  unread += tempConvo.unread
                }
              })
              payload.conversations = temp
              payload.unread = unread
              payload.bubble = state.onChatPage ? false : bubble
              payload.defaultChatbotCredentials = defaultChatbotCredentials
              payload.defaultChatbotAgent = defaultChatbotAgent
              payload.title = title
              if (!payload.watchedRecipients) {
                payload.watchedRecipients = []
              }

              commit('POPULATE_CHAT_FROM_DB', payload)
            })
          })
      } else {
        dispatch('populateChatFromDB')
      }
    } catch (err) {
      await axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  saveState: async function({ commit, state, rootState }) {
    try {
      let unread = 0
      state.conversations.forEach(convo => {
        unread += convo.unread
      })
      commit('SET_UNREAD', unread)
      await axios.post('/api/updateModule', {
        params: {
          moduleState: state,
          moduleName: MODULES.CHAT,
          pcs: localStorage.getItem('pcs'),
          classId: rootState.auth.classId,
        },
      })
    } catch (err) {
      await axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  addMessageToState({ commit, dispatch, rootState }, payload) {
    // If the sender is the logged in user, check if the recipient is in the watched recipients list and remove it if it is
    if (payload.senderid === rootState.auth.user.id) {
      let watchedRecipient = state.watchedRecipients.find((item) => {
        return item.recipientid === payload.recipientid
      })
      if (watchedRecipient) {
        dispatch("events/processEvent", { eventId: watchedRecipient.event_id }, { root: true });
        commit('REMOVE_WATCHED_RECIPIENT', watchedRecipient)
      }
    }

    commit('ADD_MESSAGE', {conversation: payload, receiving: false, rootState})
    dispatch('saveState')
  },

  receiveMessage({ commit, dispatch, rootState }, payload) {
    commit('ADD_MESSAGE', {conversation: payload, receiving: true, rootState})
    dispatch('saveState')
  },

  sendMessage: ({ commit, dispatch, rootState }, payload) => {
    try {
      let video = ''
      let captions = ''
      if (payload.video && payload.video !== '') { // If the message contains a video file path, fix the URL
        video = process.env.MIX_BASE_URL + payload.video
      }
      if (payload.captions && payload.captions !== '') { // If the message contains a video file path, fix the URL
        captions = process.env.MIX_BASE_URL + payload.captions
      }
      
      // Find the conversation from the list of conversations
      let conversation = state.conversations.find(convo => {
        return (convo.name === payload.sender && payload.senderid === convo.id) || (convo.id === payload.recipientid)
      })
      if (conversation) { // If the conversation exists, send the message
        commit('SEND_MESSAGE', {...payload, video, captions})
        dispatch('saveState')

        if (!conversation.chatbot) {
          axios.post('/api/message', {
            params: {
              message: payload.message,
              pcs: localStorage.getItem('pcs'),
              classId: rootState.auth.classId,
              recipient: payload.recipient,
              recipientid: payload.recipientid,
              name: payload.sender,
              id: payload.senderid,
              timestamp: new Date(),
              all: false,
              video,
            },
          })
        }
      }
    } catch (err) {
      axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  
  triggerDialogflow: ({ commit, dispatch, state }, payload) => {
    try {
      return new Promise(function(resolve) {
        let index = state.conversations.findIndex(convo => {
          return convo.id === payload.recipientid
        })

        if (payload.credentials_key_path && payload.agent_id) {
          commit('SET_CHATBOT_CREDENTIALS', {...payload, index})
          dispatch('saveState')
        }

        if (!state.sessionToken) {
          commit('SET_CHAT_SESSION_TOKEN')
        }
        axios.post('/api/dialogflow/sendMessage', {
          params: {
            credentials_relative_key_path: state.conversations[index].credentials || state.defaultChatbotCredentials,
            message: payload.message,
            agent: state.conversations[index].agent_id || state.defaultChatbotAgent,
            session_token: state.sessionToken,
            input_contexts: state.lastContexts || []
          },
        }).then(response => {
          commit('UPDATE_LAST_CONTEXTS', response.data.outputContexts)

          // single message response
          if (response.data.responseType == 1) {
            let conversation = state.conversations[index]
            let sender = conversation.name

            if (conversation.id < 0 && conversation.defaultSender) {
              sender = conversation.defaultSender
            }

            let data = {
              message: response.data.fulfillmentText,
              general: payload.general,
              sender: sender,
              senderid: conversation.id,
              event: payload.is_event,
              recipient: payload.recipient,
              recipientid: payload.recipientid,
            }

            let watchedResponse = state.watchedResponses.find(item => {
              return item.response === response.data.fulfillmentText
            })
            if (watchedResponse) {
              dispatch("events/processEvent", { eventId: watchedResponse.event_id }, { root: true });
              commit('REMOVE_WATCHED_RESPONSE', watchedResponse)
            }

            if (!payload.returnMessages) {
              dispatch('sendMessage', data)
            }
            resolve(data)
          }
          // multiple messages response
          else if (response.data.responseType == 2) {
            let messages = []
            response.data.fulfillmentMessages.forEach((fulfillmentMessage) => {
              let data = {
                message: fulfillmentMessage.msg,
                video: fulfillmentMessage.new_video,
                captions: fulfillmentMessage.new_captions,
                image: fulfillmentMessage.image,
                sender: fulfillmentMessage.name,
                event: payload.is_event,
                recipientid: payload.recipientid,
                senderid: state.conversations[index].id,
                recipient: payload.recipient,
              }

              let watchedResponse = state.watchedResponses.find(item => {
                return item.response === fulfillmentMessage.msg
              })
              if (watchedResponse) {
                dispatch("events/processEvent", { eventId: watchedResponse.event_id }, { root: true });
                commit('REMOVE_WATCHED_RESPONSE', watchedResponse)
              }

              if (payload.returnMessages) {
                messages.push(data)
              }
              else {
                dispatch('sendMessage', data)
              }
            })
            if (payload.returnMessages) {
              resolve(messages)
            }
          }
        })
      })
    } catch (err) {
      axios.post('/api/log_error', {
        params: {
          error: err.message,
        }
      })
      console.log("Failed")
      console.log(err)
      return false
    }
  },
  openBubble: ({ commit, dispatch }, payload) => {
    commit('OPEN_BUBBLE_CHAT')
  },
  closeBubble: ({ commit, dispatch }, payload) => {
    commit('CLOSE_BUBBLE_CHAT')
  },
  setBubbleVisibility: ({ commit }, payload) => {
    commit('SET_BUBBLE_VISIBILITY', payload)
  },
  setOnChatPage: ({commit}, payload) => {
    commit('SET_ON_CHAT_PAGE', payload)
  },
  setLoading: ({commit}, payload) => {
    commit('SET_LOADING', payload)
  },
  addTyping: ({commit}, payload) => {
    commit('ADD_TYPING', payload)
  },
  removeTyping: ({commit}, payload) => {
    commit('REMOVE_TYPING', payload)
  },
  clearState({ commit }) {
    commit('CLEAR_STATE')
  }
}

// commit
export const mutations = {
  ADD_WATCHED_RECIPIENT: (state, payload) => {
    let data = {
      recipientid: payload.recipientid,
      event_id: payload.event_id
    }
    state.watchedRecipients.push(data)
  },
  REMOVE_WATCHED_RECIPIENT: (state, watchedRecipient) => {
    let index = state.watchedRecipients.indexOf(watchedRecipient)
    if (index !== -1) {
      state.watchedRecipients.splice(index, 1)
    }
  },
  ADD_WATCHED_RESPONSE: (state, payload) => {
    let data = {
      response: payload.response,
      event_id: payload.event_id
    }
    state.watchedResponses.push(data)
  },
  REMOVE_WATCHED_RESPONSE: (state, watchedResponse) => {
    let index = state.watchedResponses.indexOf(watchedResponse)
    if (index !== -1) {
      state.watchedResponses.splice(index, 1)
    }
  },
  SET_UNREAD: (state, payload) => {
    state.unread = payload
  },
  ADD_UNREAD: (state, payload) => {
    state.unread += payload
  },
  RESET_UNREAD: (state, conversation) => {
    state.conversations.find(convo => convo.id == conversation.id).unread = 0
  },
  SET_CHATBOT_CREDENTIALS: (state, payload) => {
    state.conversations[payload.index].credentials = payload.credentials_key_path
    state.conversations[payload.index].agent_id = payload.agent_id
  },
  ADD_MESSAGE: (state, payload) => {
    let conversation = null
    if (payload.receiving && payload.conversation.recipientid >= 0) { // If the message is from someone else
      conversation = state.conversations.find(convo => {
        return convo.name === payload.conversation.sender && convo.id === payload.conversation.senderid // Check if the sender name and ID match the payload sender and ID
      })
    } else {
      conversation = state.conversations.find(convo => {
        return convo.name === payload.conversation.recipient && convo.id === payload.conversation.recipientid // Check if the recipient name and ID match the payload recipient and ID
      })
    }

    if (conversation) {
      // Check if the message is from someone else AND the conversation isn't currently open
      if ((payload.conversation.sender !== payload.rootState.auth.user.name) && ((payload.conversation.currentConversation === null) || (payload.conversation.currentConversation.id !== conversation.id))) {
        conversation.unread++
      }

      conversation.messages.push({
        senderName: payload.conversation.sender,
        message: payload.conversation.message,
        senderId: payload.conversation.senderid,
        timestamp: payload.conversation.timestamp,
        videoUrl: payload.conversation.video,
      })

    } else {
      console.log('conversation is not set')
    }
  },
  SEND_MESSAGE: (state, payload) => {
    let conversation = state.conversations.find(convo => {
      return (convo.name === payload.sender && payload.senderid === convo.id) || (convo.id === payload.recipientid)
    })
    conversation.messages.push({
      senderName: payload.sender,
      message: payload.message,
      senderId: payload.senderid,
      timestamp: new Date(),
      videoUrl: payload.video,
      captionsPath: payload.captions,
    })
    if (payload.event) { // If the message is part of an event, increment the event's unread count
      conversation.unread += 1
    }
    if (payload.senderid === conversation.id) { 
      payload.recipient = conversation.name
      payload.recipientid = conversation.id
    }
  },
  SHOW_CHAT: (state) => {
    state.showChat = !state.showChat
  },
  POPULATE_CHAT_FROM_DB: (state, newContent) => {
    state.title = newContent.title
    state.bubble = newContent.bubble
    state.conversations = newContent.conversations
    state.unread = newContent.unread
    state.sessionToken = newContent.sessionToken
    state.lastContexts = newContent.lastContexts
    state.defaultChatbotCredentials = newContent.defaultChatbotCredentials
    state.defaultChatbotAgent = newContent.defaultChatbotAgent
    state.watchedRecipients = newContent.watchedRecipients
    state.watchedResponses = newContent.watchedResponses
  },
  SET_CHAT_SESSION_TOKEN: (state) => {
    state.sessionToken = uuidv4()
  },
  UPDATE_LAST_CONTEXTS: (state, contexts) => {
    state.lastContexts = contexts
  },
  INIT_CHAT: (state, settings) => {
    settings.channels.forEach(channel => {
      channel.messages = []
      state.conversations.push(channel)
    })
    settings.users.forEach(user => {
      if (user.id >= 0) {
        user.unread = 0
      }
      user.messages = []
      state.conversations.push(user)
    })
    state.bubble = settings.bubble
    state.defaultChatbotCredentials = settings.defaultChatbotCredentials
    state.defaultChatbotAgent = settings.defaultChatbotAgent
    state.title = settings.title
  },
  OPEN_BUBBLE_CHAT: (state) => {
    state.bubbleOpen = true;
  },
  CLOSE_BUBBLE_CHAT: (state) => {
    state.bubbleOpen = false;
  },
  SET_BUBBLE_VISIBILITY: (state, payload) => {
    state.bubble = payload
    state.loading = true
  },
  SET_LOADING: (state, payload) => {
    state.loading = payload
  },
  ADD_TYPING: (state, payload) => {
    state.typing.push(payload)
  },
  REMOVE_TYPING: (state, payload) => {
    let index = state.typing.indexOf(payload)
    if (index !== -1) {
      state.typing.splice(index, 1)
    }
  },
  SET_ON_CHAT_PAGE: (state, payload) => {
    state.onChatPage = payload
  },
  CLEAR_STATE: (state) => {
    state.title = ''
    state.conversations = []
    state.showChat = false
    state.bubble = false
    state.unread = 0
    state.bubbleOpen = false
    state.onChatPage = false
    state.loading = false
    state.sessionToken = ''
    state.lastContexts = []
    state.defaultChatbotCredentials = {}
    state.defaultChatbotAgent = {}
    state.watchedRecipients = []
    state.watchedResponses = []
  }
}
